import { List as IList, Map as IMap, fromJS } from 'immutable';
import { Big } from 'big.js';

export const getQueryParams = () => {
    const params = new URLSearchParams(window.location.search);
    return {
        currency: params.get('currency'),
        egcDefaultAmount: params.get('egc_da') ? new Big(parseFloat(params.get('egc_da')).toFixed(2)) : null,
        plasticDefaultAmount: params.get('plastic_da') ? new Big(parseFloat(params.get('plastic_da')).toFixed(2)) : null
    };
};

const createCatalogMap = (catalog) => {
    const electronicCatalog = catalog.get('electronicCatalog', IMap());
    const plasticCatalog = catalog.get('plasticCatalog', IMap());
    const maxTransactionAmount = catalog.get('maxTransactionAmount');
    const uyopFeeAmount = catalog.get('uyopFeeAmount', '0.00');
    const plasticActivationFeeAmount = catalog.has('plasticActivationFeeAmount') ? catalog.get('plasticActivationFeeAmount') : '0.00';
    const digitalActivationFeeAmount = catalog.has('digitalActivationFeeAmount') ? catalog.get('digitalActivationFeeAmount') : '0.00';
    const brandCode = catalog.get('brandCode', '');
    const cpfFlag = catalog.get('cpfFlag', false);
    const currency = catalog.get('currency', null);
    const queryParams = getQueryParams();

    const isActiveCurrency = queryParams.currency === currency;
    const changeEgcDefaultAmount = queryParams.egcDefaultAmount && isActiveCurrency;
    const changePlasticDefaultAmount = queryParams.plasticDefaultAmount && isActiveCurrency;

    return IMap({
        egcRangedCatalog: electronicCatalog.get('rangedCatalog', IMap()),
        egcFixedCatalog: electronicCatalog.get('fixedCatalog', IList()),
        plasticRangedCatalog: plasticCatalog.get('rangedCatalog', IMap()),
        plasticFixedCatalog: plasticCatalog.get('fixedCatalog', IList()),
        egcRecommendedDenoms: electronicCatalog.get('recommendedDenoms', IList()),
        plasticRecommendedDenoms: plasticCatalog.get('recommendedDenoms', IList()),
        egcDefaultAmount: changeEgcDefaultAmount ? queryParams.egcDefaultAmount : electronicCatalog.get('defaultAmount'),
        plasticDefaultAmount: changePlasticDefaultAmount ? queryParams.plasticDefaultAmount : plasticCatalog.get('defaultAmount'),
        uyopFeeAmount,
        plasticActivationFeeAmount,
        digitalActivationFeeAmount,
        maxTransactionAmount,
        brandCode,
        cpfFlag
    });
};


export const parseCatalogs = catalogs => fromJS(catalogs)
    .mapEntries(([currency, catalog]) => {
        if (IList.isList(catalog)) {
            const parsedCatalogs = catalog.map((brandCatalog) => {
                const catalogWithCurrency = new Map(brandCatalog);
                catalogWithCurrency.set('currency', currency);
                return createCatalogMap(catalogWithCurrency);
            });
            return [
                currency,
                parsedCatalogs
            ];
        }
        const catalogWithCurrency = new Map(catalog);
        catalogWithCurrency.set('currency', currency);
        return [
            currency,
            createCatalogMap(catalogWithCurrency)
        ];
    });

export const getInCatalog = (catalog, keys, defaultValue = null, catalogIndex = 0) => {
    if (IList.isList(catalog)) {
        return catalog.get(catalogIndex).getIn(keys, defaultValue);
    }
    return catalog.getIn(keys, defaultValue);
};
